import React from 'react';
import { Statistic, Typography, Space, Tooltip } from 'antd';
import { ExperimentOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface StatisticWithMockProps {
    title: string;
    realValue: number;
    mockValue?: number;
    prefix?: React.ReactNode;
    suffix?: string;
    showMockData?: boolean;
    footer?: React.ReactNode;
    precision?: number;
}

export const StatisticWithMock: React.FC<StatisticWithMockProps> = ({
    title,
    realValue,
    mockValue = 0,
    prefix,
    suffix,
    showMockData = false,
    footer,
    precision = 0,
}) => {
    const totalValue = realValue + mockValue;

    if (!showMockData || mockValue === 0) {
        return (
            <div>
                <Statistic
                    title={title}
                    value={realValue}
                    prefix={prefix}
                    suffix={suffix}
                    valueStyle={{ color: '#52c41a' }}
                    precision={precision}
                />
                {footer && <div style={{ marginTop: 8 }}>{footer}</div>}
            </div>
        );
    }

    return (
        <div>
            <Statistic
                title={
                    <Space>
                        {title}
                        <Tooltip title="Showing real data only (mock data excluded from main count)">
                            <ExperimentOutlined style={{ fontSize: 12, color: '#8c8c8c' }} />
                        </Tooltip>
                    </Space>
                }
                value={realValue}
                prefix={prefix}
                suffix={suffix}
                valueStyle={{ color: '#52c41a' }}
                precision={precision}
            />
            <div style={{ marginTop: -8 }}>
                <Tooltip title={`${mockValue} mock records included for testing`}>
                    <Text
                        type="secondary"
                        style={{
                            fontSize: 12,
                            fontStyle: 'italic',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 4
                        }}
                    >
                        <ExperimentOutlined style={{ fontSize: 10 }} />
                        +{mockValue} mock
                        <Text type="secondary" style={{ fontSize: 10, marginLeft: 4 }}>
                            (Total: {totalValue})
                        </Text>
                    </Text>
                </Tooltip>
            </div>
            {footer && <div style={{ marginTop: 8 }}>{footer}</div>}
        </div>
    );
};